import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import dynamicfunction from '../../utils/dynamicfunction';
import { getContentKeyAccToLang } from '../../utils/utils';
import { setIsCorporate } from '../../store/slices/constantSlice';

export default () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { authContent } = useSelector((state) => state.content);
  const { TextWeight, isArabic } = dynamicfunction();

  const getContentKey = (key) => {
    return getContentKeyAccToLang(authContent?.account_type?.data?.attributes, key, isArabic);
  };

  const onChooseType = (type) => {
    dispatch(setIsCorporate(type === 'corporate'));
    navigate('/create-account');
  };

  return {
    TextWeight,
    isArabic,
    getContentKey,
    navigate,
    onChooseType,
  };
};
